import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import { useSwipeable } from 'react-swipeable'
import { Slide } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import ContainedSection from 'artkive/components/PageSections/ContainedSection'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import { BREAKPOINTS } from 'artkive/utils/constants'

import ArrowLeft from 'images/ecom/ArrowLeft.svg'
import ArrowRight from 'images/ecom/ArrowRight.svg'

import ProductSlide from './ProductSlide'
import {
  BackgroundWrapper,
  CardsWrapper,
  Container,
  LeftArrowButton,
  RightArrowButton,
  SectionTitle,
} from './YouWillAlsoLoveCarousel.style'

const useStyles = makeStyles(({ breakpoints }) => ({
  container: {
    [breakpoints.up(BREAKPOINTS.lg)]: {
      maxWidth: 1200,
    },
    [breakpoints.up(1360)]: {
      maxWidth: 1320,
    },
  },
  slides: {},
}))

const YouWillAlsoLoveCarousel = ({ slides, className, classes: classesProp }) => {
  const classes = useStyles({ classes: classesProp })
  const isMobile = useMobileBreakpoint()

  const [slide, setSlide] = useState(0)
  const [direction, setDirection] = useState('left')

  const handleNext = useCallback(() => {
    setDirection('left')
    setSlide((prevSlide) => (prevSlide >= slides.length - 1 ? 0 : prevSlide + 1))
  }, [slides.length])

  const handlePrev = useCallback(() => {
    setDirection('right')
    setSlide((prevSlide) => (prevSlide <= 0 ? slides.length - 1 : prevSlide - 1))
  }, [slides.length])

  const handlers = useSwipeable({ onSwipedLeft: handleNext, onSwipedRight: handlePrev })

  return (
    <ContainedSection
      title={
        <SectionTitle align='center' gutterBottom variant='h2'>
          You'll Also Love
        </SectionTitle>
      }
      component={BackgroundWrapper}
      className={className}
      containerClassName={classes.container}
    >
      <Container className={classes.slides} {...(!isMobile ? handlers : {})}>
        {!isMobile && slides.length > 1 && (
          <LeftArrowButton disableRipple aria-label='Show previous slide' onClick={handlePrev}>
            <img src={ArrowLeft} />
          </LeftArrowButton>
        )}
        <CardsWrapper>
          {slides.map((productSlide, index) =>
            isMobile ? (
              <ProductSlide key={productSlide.title} {...productSlide} />
            ) : (
              <Slide key={productSlide.title} in={slide === index} mountOnEnter direction={direction}>
                <ProductSlide {...productSlide} />
              </Slide>
            ),
          )}
        </CardsWrapper>
        {!isMobile && slides.length > 1 && (
          <RightArrowButton disableRipple aria-label='Show next slide' onClick={handleNext}>
            <img src={ArrowRight} />
          </RightArrowButton>
        )}
      </Container>
    </ContainedSection>
  )
}

YouWillAlsoLoveCarousel.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      buttonLabel: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      imageSrc: PropTypes.string.isRequired,
      trackerEvent: PropTypes.string,
      trackerOptions: PropTypes.object,
      badge: PropTypes.string,
      price: PropTypes.node,
      classes: PropTypes.object,
    }),
  ),
  className: PropTypes.string,
  classes: PropTypes.object,
}

export default YouWillAlsoLoveCarousel
